<template>
  <div class="sleep">
    <div class="back" @click="$router.go(-1)">
      <i class="el-icon-back"></i> <span>返回上一页</span>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="睡眠" name="first">
        <el-table :data="tableData" :border="true">
          <el-table-column
            label="序号"
            width="80"
            align="center"
            type="index"
            prop=""
          >
          </el-table-column>
          <el-table-column label="开始时间" align="center" prop="StartTime">
            <template slot-scope="scope" align="center">
              {{ scope.row.StartTime | handtime }}
            </template>
          </el-table-column>
          <el-table-column label="结束时间" align="center" prop="EndTime">
            <template slot-scope="scope" align="center">
              {{ scope.row.EndTime | handtime }}
            </template>
          </el-table-column>
          <el-table-column label="设备型号" align="center" prop="DeviceType">
            <template slot-scope="scope" align="center">
              {{ scope.row.DeviceType || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="总睡眠时长" align="center" prop="Total">
            <template slot-scope="scope" align="center">
              {{ scope.row.Total |handSleep }}
            </template>
          </el-table-column>
          <el-table-column label="实际睡眠时长" align="center" prop="RealDuration">
            <template slot-scope="scope" align="center">
              {{ scope.row.RealDuration |handSleep }}
            </template>
          </el-table-column>
          <el-table-column label="深睡时长" align="center" prop="DeepDuration">
            <template slot-scope="scope" align="center">
              {{ scope.row.DeepDuration |handSleep }}
            </template>
          </el-table-column>
          <el-table-column label="浅睡时长" align="center" prop="ShallowDuration">
            <template slot-scope="scope" align="center">
              {{ scope.row.ShallowDuration |handSleep }}
            </template>
          </el-table-column>
          <el-table-column label="清醒时长" align="center" prop="WakeDuration">
            <template slot-scope="scope" align="center">
              {{ scope.row.WakeDuration |handSleep }}
            </template>
          </el-table-column>
          <el-table-column label="睡眠质量" align="center" prop="Quality">
            <template slot-scope="scope" align="center">
              {{ scope.row.Quality }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="->,total,prev, pager, next"
          :total="total"
          :current-page="page"
          :page-size="size"
          @current-change="changefn"

        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { requestUserSleepData } from "@/api/userApi";
import { handtime } from "@/utils/util";
export default {
  name: "sleep",
  data() {
    return {
      activeName: "first",
      page: 1,
      size: 10,
      total: 0,
      tableData: [
        {
          date: 111,
        },
      ],
    };
  },
  created() {
    this.requestUserSleepDatafn();
  },
  filters:{
    handtime,
    handSleep(minute){
      if(minute){

 return  Math.floor(minute/60) + "小时" +(minute%60 )+"分"
      }else{
        return "-"
      }

    }
  },
  methods: {
    changefn(index){
      this.page=index;
      this.requestUserSleepDatafn();

    },
    async requestUserSleepDatafn() {
      var res = await requestUserSleepData({
        userId: this.$route.query.id,
        page: this.page,
        size: this.size,
      });
      console.log(res.data.data.result);
      this.tableData = res.data.data.result.list;
      this.total = res.data.data.result.count;
    },
  },
};
</script>

<style lang="less">
.sleep {
  padding: 15px;
  position: relative;
  .back {
    position: absolute;
    right: 40px;
    top: 15px;
    height: 40px;
    line-height: 40px;
    color: #4276ff;
    z-index: 999;
    cursor: pointer;
  }
  .el-table {
    margin-bottom: 20px;
  }
  thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
}
</style>